<template>
  <el-select @change="onChange" v-model="status" placeholder="发放状态">
    <el-option
        v-for="item in status_opitons"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
  </el-select>
</template>

<script>


export default {
  name: "status-option",
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.status = newVal
      }
    }
  },
  data() {
    return {
      status: undefined,
      status_opitons:[
          {label: '未发放', value: "normal"},
          {label: '已发放', value: "received"},
      ]
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.status)
    }
  }
}
</script>

<style scoped>

</style>